import { createAction } from '@reduxjs/toolkit';

import { AcadlyPage } from '../db/shared/types';
import { PageStatus } from './types';

interface SetPageStatusPayload {
  page: AcadlyPage;
  status: PageStatus;
}

export const setPageStatus = createAction<SetPageStatusPayload>('pages/status');
